import { useEffect, useState } from "react";
import CourseTableRow from "./CourseTableRow";
import { Course_Table_Model } from "../../Models/CoursesModel";
import { useSelector } from "react-redux";
function CourseTable({
  Courses_Lists,
  Courses_Lists_Get_Req,
  handleDeleteCourse,
  handleEditCourseData,
  setCourses_Lists,
  TableFilter,
}) {
  const [CoursesPage_data, setCoursesPage_data] = useState(Courses_Lists);
  const { Courses_Count } = useSelector(
    (state) => state.COURSES_TOTAL_DATA_REDUCER
  );

  let records = Math.ceil(
    Courses_Count && Courses_Count[0].total / TableFilter.PageSize
  );
  const arr = Array.from({ length: records }, (_, index) => index + 1);

  const handlePage = async (page) => {
    await Courses_Lists_Get_Req({
      ...TableFilter,
      PageNo: TableFilter.PageNo + page,
    });
  };
  const Total_Records = Courses_Count && Courses_Count[0].total;

  const handleSinglePage = (page) => {
    Courses_Lists_Get_Req({ ...TableFilter, PageNo: page });
  };
  const handleTablePageCount = (e) => {
    Courses_Lists_Get_Req({ ...TableFilter, PageSize: +e.target.value });
  };

  useEffect(() => {
    setCoursesPage_data(Courses_Lists);
  }, [Courses_Lists]);

  return (
    <div className="col-md-9 col-lg-10">
      <div className="coctacts-table">
        <div className="table-responsive custom-scroll-right-bottum">
          <table className="table table-condensed ">
            <thead className="t-head-th-bg">
              <tr>
                {Course_Table_Model?.map((el, i) => (
                  <th className="t-head-fixed" key={i}>
                    {el}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="table-bordered">
              {CoursesPage_data?.map((el,i) => (
                <CourseTableRow
                  key={i}
                  {...el}
                  setCourses_Lists={setCourses_Lists}
                  Courses_Lists_Get_Req={Courses_Lists_Get_Req}
                  handleEditCourseData={handleEditCourseData}
                  handleDeleteCourse={handleDeleteCourse}
                />
              ))}
            </tbody>
          </table>
        </div>
        <div className="Pagination">
          <div className="table-page-details">
            <div className="row">
              <div className="col-md-9">
                <div className="page-number">
                  <ul className="pagination justify-content-center">
                    <li className="page-item">
                      <button
                        onClick={() => handlePage(-1)}
                        disabled={+TableFilter.PageNo === 1}
                        className={
                          TableFilter.PageNo === 1
                            ? "page-link deactive"
                            : "page-link button_color"
                        }>
                        Previous
                      </button>
                    </li>
                    {arr?.map((el, i) => (
                      <li
                        onClick={() => handleSinglePage(+el)}
                        key={i}
                        className={
                          i <= TableFilter.PageNo + 4 &&
                          i >= TableFilter.PageNo - 3
                            ? "page-item"
                            : "page-item2"
                        }>
                        <a
                          className={
                            i === TableFilter.PageNo - 1
                              ? "active_button page-link"
                              : "page-link"
                          }>
                          {el}
                        </a>
                      </li>
                    ))}
                    <li className="page-item">
                      <button
                        onClick={() => {
                          handlePage(1);
                        }}
                        disabled={
                          TableFilter.PageNo ===
                          Math.ceil(Total_Records / TableFilter.PageSize)
                        }
                        className={
                          TableFilter.PageNo ===
                          Math.ceil(Total_Records / TableFilter.PageSize)
                            ? "page-link deactive"
                            : "page-link button_color"
                        }
                        href="#">
                        Next
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-3 text-center">
                <div className="page-counter">
                  <label>
                    <select
                      value={TableFilter.PageSize}
                      onChange={(e) => {
                        handleTablePageCount(e);
                      }}>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>{" "}
                    of <span>{Courses_Count && Courses_Count[0]?.total}</span>{" "}
                    records
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CourseTable;
